// extracted by mini-css-extract-plugin
export default {"headerBannerMain":"oCwFwHDbEW","headerBanner":"k0ROZoMmRR","headerBannerContent":"yfxSHGsODA","legalDisclaimer":"DSi8zPvgGY"};